import {constructTableRequestParams} from "./util";
import request from 'utils/RequestManager';
import config from '../../config';

const backendURL = config.BACKEND_HOST;

export function getStatisticNumbers(companyIds, operatorId = null) {

    const params = new URLSearchParams();

    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    if (operatorId !== null) {
        params.append('operatorId', operatorId);
    }

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/numbers',
        params,
    })
        .then(response => response.data);
}

export function getModalData(filters = {}, pageable = {}) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters, pageable);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/conversation-data',
        params
    })
        .then(response => response.data);
}

export function generateModalDataExcel(filename, filters) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/excel/modal-data',
        responseType: 'blob',
        params
    }).then(response => {
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename + '.xlsx';
        link.click();

        window.URL.revokeObjectURL(url);
    });
}

export function getBotStatisticNumbers(filters = {}, pageable = {}) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters, pageable);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/bot-numbers',
        params
    })
        .then(response => response.data);
}

export function getOperatorsTableData(parentCompanyId, filters = {}, pageable = {}) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters, pageable);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/statistic/operators/${parentCompanyId}`,
        params
    })
        .then(response => response.data);
}

export function getOperatorsLoginLogoutData(filters = {}, pageable = {}) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters, pageable);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/statistic/operators-login-logout-data`,
        params
    })
        .then(response => response.data);
}

export function generateOperatorsLoginLogoutExcel(filename, filters) {
    const adjustedFilters = { ...filters };

    if (adjustedFilters.start) {
        adjustedFilters.start = `${adjustedFilters.start}T00:00:00`;
    }
    if (adjustedFilters.end) {
        adjustedFilters.end = `${adjustedFilters.end}T23:59:59`;
    }

    const params = constructTableRequestParams(adjustedFilters);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/excel/operators-login-logout',
        responseType: 'blob',
        params
    }).then(response => {
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename + '.xlsx';
        link.click();

        window.URL.revokeObjectURL(url);
    });
}

export function getOperatorsTimes(companyIds, operatorIds = [],start = null,end = null) {

    const params = new URLSearchParams();

    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    operatorIds.forEach((id) => {
        params.append('operatorIds', id);
    })

    if(start)params.append('start', `${start}T00:00:00`);
    if(end)params.append('end', `${end}T23:59:59`);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/operators/time-statistics',
        params,
    })
        .then(response => response.data);
}


// WEBPACK FOOTER //
// ./src/services/statistics/api.js